import { render, staticRenderFns } from "./control-event-point.vue?vue&type=template&id=1b1f857f&"
import script from "./control-event-point.vue?vue&type=script&lang=js&"
export * from "./control-event-point.vue?vue&type=script&lang=js&"
import style0 from "./control-event-point.vue?vue&type=style&index=0&id=1b1f857f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports